// This function is used to update hooks and get updated communityHubUsers from
// order. It also loads the user emails if being called from the delivery volunteers
import CreateVisibleCommunityOrders from "../../../../components/dialogs/functions/CreateVisibleCommunityOrders.js";
import LoadUserEmails from "../../../../components/dialogs/Components/SendUserEmails/LoadUserEmails.js";
import SetBaseDeliveryFees from "../../../../components/dialogs/Components/SendUserEmails/functions/SetBaseDeliveryFees.js";

export default async function RefreshCommunityHubData(
  order,
  communityLocation,
  communityOrderChunksTemp,
  setCommunityOrderChunks,
  setCommunityHubUsers,
  setBaseDeliveryFee,
  setMinDeliveryFees,
  setUserEmails,
  setLoadingEmails,
) {
  if (!order) return;

  // Build the community hub users
  let communityHubUsersTemp = CreateVisibleCommunityOrders(
    order.communityOrders,
    null,
    null,
    false,
    [],
  );

  // If there is a single communityLocation then we want to only have that one.
  if (communityLocation) {
    // Keep only the current community location
    communityHubUsersTemp = {
      [communityLocation]: communityHubUsersTemp[communityLocation] || {},
    };
  } else {
    delete communityHubUsersTemp["Pickup On Site"];
  }

  // Calculate delivery fees
  const { baseDeliveryFees, minDeliveryFees } = SetBaseDeliveryFees(
    communityHubUsersTemp,
  );

  // Load user emails
  let userEmailsTemp = {};

  // Update chunks
  setCommunityOrderChunks([...communityOrderChunksTemp]);
  // is setCommunityHubUsers is not null we know it came from
  // the volunteer and so all these hooks can be updated otherwise
  // it's from the distribution location and doesn't need to be updated.
  if (setCommunityHubUsers) {
    userEmailsTemp = await LoadUserEmails(
      {},
      {},
      setLoadingEmails,
      setUserEmails,
      communityHubUsersTemp,
    );
    // Update community hubs
    setCommunityHubUsers({ ...communityHubUsersTemp });
    // Set delivery fees
    setBaseDeliveryFee(baseDeliveryFees);
    setMinDeliveryFees(minDeliveryFees);
    setUserEmails(userEmailsTemp);
  }

  return {
    communityHubUsers: communityHubUsersTemp,
    userEmails: userEmailsTemp,
    baseDeliveryFees,
    minDeliveryFees,
  };
}
